import React, { createContext, useContext, ReactNode } from 'react';

interface ApiDataContextType {
  services: { id: number; name: string; category: string; type: string; }[];
  suppliers: { id: number; name: string; cnpj: string; contactName: string; email: string; phone: string; }[];
  scripts: string[];
}

const ApiDataContext = createContext<ApiDataContextType | null>(null);

interface ApiDataProviderProps {
  children: ReactNode;
  services: { id: number; name: string; category: string; type: string; }[];
  suppliers: { id: number; name: string; cnpj: string; contactName: string; email: string; phone: string; }[];
  scripts: string[];
}

export const ApiDataProvider: React.FC<ApiDataProviderProps> = ({
  children,
  services,
  suppliers,
  scripts,
}) => {
  const value = {
    services,
    suppliers,
    scripts,
  };

  return (
    <ApiDataContext.Provider value={value}>
      {children}
    </ApiDataContext.Provider>
  );
};

export const useApiData = () => {
  const context = useContext(ApiDataContext);
  if (!context) {
    throw new Error('useApiData must be used within an ApiDataProvider');
  }
  return context;
};
